import { render, staticRenderFns } from "./AchievementsPage.vue?vue&type=template&id=3334314d&scoped=true"
import script from "./AchievementsPage.vue?vue&type=script&lang=js"
export * from "./AchievementsPage.vue?vue&type=script&lang=js"
import style0 from "./AchievementsPage.vue?vue&type=style&index=0&id=3334314d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3334314d",
  null
  
)

export default component.exports